import React from 'react';

import type { IIcon } from '../types.ts';
import Aac from './Aac.tsx';
import Ai from './Ai.tsx';
import Avi from './Avi.tsx';
import Csv from './Csv.tsx';
import Doc from './Doc.tsx';
import Docx from './Docx.tsx';
import Empty from './Empty.tsx';
import Fla from './Fla.tsx';
import Flac from './Flac.tsx';
import Gif from './Gif.tsx';
import Htm from './Htm.tsx';
import Html from './Html.tsx';
import Jpeg from './Jpeg.tsx';
import Jpg from './Jpg.tsx';
import Mov from './Mov.tsx';
import Mp3 from './Mp3.tsx';
import Mp4 from './Mp4.tsx';
import Pdf from './Pdf.tsx';
import Png from './Png.tsx';
import Ppt from './Ppt.tsx';
import Ps from './Ps.tsx';
import Tiff from './Tiff.tsx';
import Txt from './Txt.tsx';
import Xls from './Xls.tsx';
import Xlsx from './Xlsx.tsx';
import Xml from './Xml.tsx';

const FileTypes = {
  aac: Aac,
  ai: Ai,
  avi: Avi,
  csv: Csv,
  doc: Doc,
  docx: Docx,
  fla: Fla,
  flac: Flac,
  gif: Gif,
  htm: Htm,
  html: Html,
  jpg: Jpg,
  jpeg: Jpeg,
  mov: Mov,
  mp3: Mp3,
  mp4: Mp4,
  pdf: Pdf,
  png: Png,
  ps: Ps,
  tiff: Tiff,
  txt: Txt,
  xls: Xls,
  xlsx: Xlsx,
  xml: Xml,
  pptx: Ppt,
};

export const availableFileTypes = Object.keys(FileTypes);

export interface IFileTypes extends IIcon {
  type: keyof typeof FileTypes | string;
}

const isSupported = (type: string): type is keyof typeof FileTypes => !!(FileTypes as Record<string, unknown>)[type];

const FileType: React.FC<IFileTypes> = ({ type, ...props }) => {
  if (isSupported(type)) {
    return React.createElement(FileTypes[type], props);
  }
  return React.createElement(Empty, props);
};

export default React.memo(FileType);
